<template>
	<div
		class="container"
		:class="[
			isBrand? 'sk' : '',
		]"
	>
		<div
			class="programm"
			:class="[
				block.appearance? block.appearance : '',
			]"
		>
			<div class="row">
				<div
					class="col-12 col-lg-6"
					:class="[
						block.is_media_position_right ? 'order-lg-1' : '',
					]"
				>
					<a :href="block.url ? block.url : '/'">
						<div v-if="block.media_type === 'image'" class="embed-responsive embed-responsive-16by9 ">
							<img
								v-if="block.media"
								:src="block.media.src"
								:alt="block.media.alt"
								class="embed-responsive-item"
							>
						</div>
						<b-embed
							v-if="block.media_type === 'video' && block.media"
							type="iframe"
							aspect="16by9"
							:src="block.media + '?rel=0&enablejsapi=1'"
							allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
							allowfullscreen
						/>
					</a>
				</div>
				<div class="col-12 col-lg">
					<div class="programm_content">
						<div class="d-flex h-100 flex-column justify-content-between">
							<div v-if="block.content_type" class="programm_header">
								<span class="programm_type">{{ block.content_type }}</span>
							</div>

							<div class="programm_content_body">
								<a :href="block.url ? block.url : '/'">
									<div v-if="block.block_title" class="title title-lg">{{ block.block_title }}</div>
									<div v-if="block.description" class="description" v-html="block.description" />
								</a>
							</div>
						</div>

						<div class="programm_content_footer">
							<a :href="block.url ? block.url : '/'" class="more_link">{{ $t('more') }}</a>

							<div v-if="block.date" class="programm_content_footer_reminder">
								{{ block.date }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '@/mixins/panel';

export default {
	name: 'PanelCa04',
	mixins: [panel],
};
</script>

<style lang="scss" scoped>
@import "~/assets/styles/components/dev/draft-cards-4";
</style>
